import { useQuery } from '@tanstack/react-query';
import { useTranslation } from '@mypoz/i18n';
import { Card, Spinner, StatusBadge } from '@mypoz/ui';

import { LanguageSwitcher } from '@/shell/LanguageSwitcher.js';
import { PageTitle, Section } from '@/components/ui.js';
import { api, apiBaseUrl } from '@/lib/api.js';

export function Settings() {
  const { t } = useTranslation();

  // Demonstrates the ApiClient + react-query wiring. With no backend running this settles into
  // the error branch, which is the honest thing for a template to show.
  const health = useQuery({
    queryKey: ['health'],
    queryFn: () => api.health(),
    retry: false,
  });

  return (
    <>
      <PageTitle title={t('settings.title')} subtitle={t('settings.subtitle')} />

      <Section title={t('language.label')}>
        <Card>
          <LanguageSwitcher />
        </Card>
      </Section>

      <Section title={t('settings.apiSection')}>
        <Card className="flex flex-col gap-3">
          <div className="flex flex-wrap items-center justify-between gap-2">
            <span className="text-sm text-muted">{t('settings.apiBaseUrl')}</span>
            <code className="rounded-sm bg-surface-alt px-2 py-1 text-sm text-ink">
              {apiBaseUrl}
            </code>
          </div>
          <div className="flex flex-wrap items-center justify-between gap-2">
            <span className="text-sm text-muted">{t('settings.apiStatus')}</span>
            {health.isPending ? (
              <Spinner size={16} />
            ) : health.isError ? (
              <StatusBadge tone="danger">{t('state.error')}</StatusBadge>
            ) : (
              <StatusBadge tone="success">{health.data.status}</StatusBadge>
            )}
          </div>
          {health.isError ? (
            <p className="text-sm text-muted">{t('settings.apiUnreachable')}</p>
          ) : null}
        </Card>
      </Section>
    </>
  );
}
